query ListMyEmoteWalls {
  walls: StreamToolsListMyEmoteWalls {
    emoteWallId
    name
    twitchChatChannels
    style
    emoteSize
    density
    durationSeconds
    showTwitchEmotes
    show7tvEmotes
    showBttvEmotes
    showFfzEmotes
    createdAt
  }
}
